import React from "react";
import { glassBox } from "../kota/ui";
import { MusikBeranda } from "./MusikBeranda";

const FONT = "'Plus Jakarta Sans', sans-serif";
const BIRU = "#0000CD";

// Ikon parasut (SVG inline, lucide tidak punya)
const Parasut = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M3 11a9 9 0 0 1 18 0Z" /><path d="M3 11l9 10 9-10" /><path d="M8 11l4 10 4-10" />
  </svg>
);

// Kartu sambutan kaca di atas peta beranda: lencana parasut biru yang bergoyang, status "DROP ZONE READY" (tetap; detail penerbangan ada di pil bawah kartu),
// judul, "Jawsel" bergaya stempel, dan tombol speaker musik yang ditanam di ujung kanan agar bagian atas peta jadi satu kesatuan.
export function SambutanBeranda() {
  const status = "DROP ZONE READY";

  return (
    <div data-testid="sambutan-beranda" onPointerDown={e => e.stopPropagation()}
      style={{ ...glassBox, position: "absolute", left: "50%", top: "calc(14px + env(safe-area-inset-top))", transform: "translateX(-50%)", zIndex: 8, width: "min(372px, calc(100% - 28px))",
               borderRadius: 24, padding: "12px 12px 12px 12px", display: "flex", alignItems: "center", gap: 12, fontFamily: FONT, animation: "sambut-masuk .7s cubic-bezier(.2,.8,.2,1) both, sambut-apung 5s ease-in-out 0.7s infinite" }}>
      <span data-testid="sambutan-lencana" style={{ width: 52, height: 52, borderRadius: 16, background: BIRU, display: "grid", placeItems: "center", flex: "none", boxShadow: "0 10px 22px rgba(0,0,205,.35)", animation: "sambut-goyang 3.2s ease-in-out infinite" }}>
        <Parasut />
      </span>
      <div style={{ minWidth: 0, flex: 1 }}>
        <span data-testid="sambutan-status" style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 10, fontWeight: 800, letterSpacing: 1.6, color: BIRU, textTransform: "uppercase" }}>
          <span style={{ width: 7, height: 7, borderRadius: 99, background: "#ef4444", boxShadow: "0 0 0 3px rgba(239,68,68,.22)", animation: "sambut-denyut 1.6s ease-in-out infinite", flex: "none" }} />
          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{status}</span>
        </span>
        <b style={{ display: "block", fontSize: 16, letterSpacing: -0.3, color: "var(--g-ink)", lineHeight: 1.2, marginTop: 2 }}>Selamat Datang</b>
        <span style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 13.5, color: "var(--g-sub)", fontWeight: 600, marginTop: 2 }}>
          Para Penerjun
          <span data-testid="sambutan-stempel" style={{ display: "inline-block", padding: "1px 7px", border: `2px solid ${BIRU}`, borderRadius: 5, color: BIRU, fontWeight: 800, fontSize: 12, letterSpacing: 1.4, textTransform: "uppercase", transform: "rotate(-5deg)", boxShadow: `inset 0 0 0 1.5px var(--g-bg), inset 0 0 0 2.5px ${BIRU}`, opacity: .92, animation: "sambut-cap .6s cubic-bezier(.2,1.4,.3,1) .5s both" }}>
            Jawsel
          </span>
        </span>
      </div>
      <MusikBeranda />
      <style>{`
        @keyframes sambut-masuk{from{opacity:0;transform:translate(-50%,-18px) scale(.96)}to{opacity:1;transform:translate(-50%,0) scale(1)}}
        @keyframes sambut-apung{0%,100%{transform:translate(-50%,0)}50%{transform:translate(-50%,-4px)}}
        @keyframes sambut-goyang{0%,100%{transform:rotate(-5deg) translateY(0)}50%{transform:rotate(5deg) translateY(-2px)}}
        @keyframes sambut-denyut{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.45;transform:scale(.7)}}
        @keyframes sambut-cap{from{opacity:0;transform:rotate(-14deg) scale(1.8)}to{opacity:.92;transform:rotate(-5deg) scale(1)}}
      `}</style>
    </div>
  );
}
